var map = {
	"./1.png": "LOA1",
	"./2.png": "NKGv",
	"./3.png": "LHqX",
	"./4.png": "+TIe",
	"./LIMS.png": "ZcF1",
	"./SES.png": "7C3j",
	"./login-1.png": "+MUi",
	"./login-2.png": "rD1l",
	"./login-3.png": "Wczi",
	"./login-4.png": "SyFL",
	"./map-csqp.png": "CX+g",
	"./map-lh.png": "3823",
	"./map-lh2.png": "agnW",
	"./map-m.png": "IuqY",
	"./map-m2.png": "nqex",
	"./map-pta.png": "B7GB",
	"./map-rtzf.png": "64kQ",
	"./map-trq.png": "EauJ",
	"./map-trq2.png": "rP/x",
	"./map-yyy.png": "zon3",
	"./map-yyy2.png": "M9B8",
	"./new4-2.png": "aRfi",
	"./new4-3.png": "nAJo",
	"./new4-4.png": "Cg7H",
	"./new8-1.png": "mZvb",
	"./new8-2.png": "iLZI",
	"./new8-3.png": "817e",
	"./new8-4.png": "0phy",
	"./new8-5.png": "fAGX",
	"./new8-6.png": "MLD/",
	"./new8-7.png": "tdTA",
	"./news14-1.png": "58y1",
	"./news14-2.png": "LtHK",
	"./news14-3.png": "L0Qp",
	"./news6-1.png": "aRYe",
	"./news6-2.png": "X6Na",
	"./news6-3.png": "mbKS",
	"./nygl1.png": "kv0n",
	"./nygl2.png": "OpMu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 4